<script setup lang="ts">
import { AppArrowScroller } from '@libs/ui';

import type { SuggestedActivityCardData } from '../../../models';

import SuggestedActivityCard from './SuggestedActivityCard.vue';

interface SuggestedActivitiesBannerProps {
  cards: SuggestedActivityCardData[];
  destination: string;
  ingredientIndex: number;
}
const props = defineProps<SuggestedActivitiesBannerProps>();

interface SuggestedActivitiesBannerEmits {
  (eventName: 'open-activity', activityCode: string): void;
}
const emit = defineEmits<SuggestedActivitiesBannerEmits>();
</script>

<template>
  <div class="suggested-activities-banner">
    <AppArrowScroller
      :items="props.cards"
      :item-key-selector="
        (suggestedActivityCard, index) => suggestedActivityCard?.name ?? index
      "
      :display-dashed-border="false"
      :left-arrow-aria-label="$t('a11y.left_arrow_previous_suggestions')"
      :right-arrow-aria-label="$t('a11y.right_arrow_next_suggestions')"
    >
      <template #item="{ item: activityCard }">
        <SuggestedActivityCard
          class="suggested-activity-card"
          :activity-card-data="activityCard"
          @open-activity="emit('open-activity', $event)"
        />
      </template>
    </AppArrowScroller>
  </div>
</template>

<style scoped lang="scss">
.suggested-activities-banner {
  padding-top: var(--spacing-8);
  background-color: var(--color-white);

  .suggested-activity-card {
    margin-right: var(--spacing-12);
  }
}
</style>
